import React from 'react';
import './style.scss';

export const RadioButtons = ({ name, options, checked, onChange, className }) => (
  <div className={`button-group ${className}`}>
    {options.map(el => (
      <label key={el.id} className="custom_radio">
        <div className={`before-item ${el.id}`} />
        <div>
          <input type="radio" name={name} onChange={() => onChange(el.id)} checked={checked === el.id} />
          <div className="custom_radio_text">{el.label}</div>
        </div>
      </label>
    ))}
  </div>
);
